import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Component that handles scrolling to top on route change
const ScrollToTopRoute = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return children;
};

export default ScrollToTopRoute;